
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const recipesteps = state => state.recipesteps;
const forrecipe = state => state.forrecipe;
const getsingle = state => param =>state.recipesteps.find((a)=> a.id == param)

export default {
  formdata,
  data,
  recipesteps,  
  forrecipe,
  dataobject,
  getsingle
};